import React, { useState } from "react";
import "../assets/CalculateSalary.css";

const CalculateSalary = () => {
  const [filters, setFilters] = useState({
    role: "",
    branch: "",
    employee: ""
  });

  const attendanceData = [
    { id: 1, employee: "Rajeev", role: "Manager", branch: "Delhi", present: 20, absent: 2, halfday: 2 },
    { id: 2, employee: "Amit", role: "HR", branch: "Mumbai", present: 18, absent: 4, halfday: 2 },
    { id: 3, employee: "Neha", role: "Agent", branch: "Kolkata", present: 22, absent: 0, halfday: 2 },
  ];

  const salaryPerDay = 1000;
  const halfDayFactor = 0.5;

  const calculateSalary = (present, halfday) => {
    return (present + halfday * halfDayFactor) * salaryPerDay;
  };

  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  return (
    <div className="CalculateSalary-container">
      <h1 className="CalculateSalary-title">Calculate Salary</h1>

      {/* Filters */}
      <div className="CalculateSalary-filterSection">
        <select name="role" onChange={handleChange} value={filters.role}>
          <option value="">Select Role</option>
          <option value="Manager">Manager</option>
          <option value="HR">HR</option>
          <option value="Agent">Agent</option>
        </select>

        <select name="branch" onChange={handleChange} value={filters.branch}>
          <option value="">Select Branch</option>
          <option value="Delhi">Delhi</option>
          <option value="Mumbai">Mumbai</option>
          <option value="Kolkata">Kolkata</option>
        </select>

        <select name="employee" onChange={handleChange} value={filters.employee}>
          <option value="">Select Employee</option>
          {attendanceData.map((emp) => (
            <option key={emp.id}>{emp.employee}</option>
          ))}
        </select>
      </div>

      {/* Table */}
      <div className="CalculateSalary-tableWrapper">
        <table className="CalculateSalary-table">
          <thead>
            <tr>
              <th>S.N.</th>
              <th>Employee</th>
              <th>Role</th>
              <th>Branch</th>
              <th>Present</th>
              <th>Absent</th>
              <th>Half Day</th>
              <th>Total Salary (₹)</th>
            </tr>
          </thead>
          <tbody>
            {attendanceData
              .filter((emp) => {
                return (
                  (!filters.role || emp.role === filters.role) &&
                  (!filters.branch || emp.branch === filters.branch) &&
                  (!filters.employee || emp.employee === filters.employee)
                );
              })
              .map((emp, index) => (
                <tr key={emp.id}>
                  <td>{index + 1}</td>
                  <td>{emp.employee||"N/A"}</td>
                  <td>{emp.role||"N/A"}</td>
                  <td>{emp.branch||"N/A"}</td>
                  <td>{emp.present||"N/A"}</td>
                  <td>{emp.absent||"N/A"}</td>
                  <td>{emp.halfday||"N/A"}</td>
                  <td>{`₹${calculateSalary(emp.present, emp.halfday).toFixed(2)}`||"N/A"}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CalculateSalary;
